import { deleteData, getData, getDataSimple, postData, putData } from "../../utils/serverHelper";
import { LOGIN, TEMPLATE, TEMPLATE_BIZZ } from "../../utils/urls";
import { errorMessage, successMessage } from "../error/action";
import { failedTemplates, loadingTemplates, successTemplates } from "./reducer"

export const getTemplates = async(dispatch)=>{
try {
    dispatch(loadingTemplates());
    const data = await getDataSimple(TEMPLATE);
    dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    dispatch(failedTemplates({})); 
}
}

export const getTemplatesByBusiness = async(dispatch)=>{
try {
    dispatch(loadingTemplates());
    const data = await getData(TEMPLATE_BIZZ);
    dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    dispatch(failedTemplates({})); 
}
}

export const addTemplates = async(dispatch,req,nav)=>{
try {
    dispatch(loadingTemplates());
    console.log(req);
    const data = await postData(TEMPLATE,req);
    await getTemplates(dispatch);
    nav(-1);
    successMessage(dispatch,"Template Added SuccessFully.")
    // dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    errorMessage(dispatch,error)
    dispatch(failedTemplates({})); 
}
}

export const deleteTemplates = async(dispatch,id,nav)=>{
try {
    dispatch(loadingTemplates());
    // console.log(req);
    await deleteData(TEMPLATE+'/'+id);
    await getTemplates(dispatch);
    // nav(-1);
    // dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    dispatch(failedTemplates({})); 
}
}

export const addTemplatesByBusiness = async(dispatch,req,nav)=>{
try {
    dispatch(loadingTemplates());
    const data = await postData(TEMPLATE_BIZZ,req);
    await getTemplatesByBusiness(dispatch);
    nav(-1);
    successMessage(dispatch,"Template Added SuccessFully.")
    // dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    errorMessage(dispatch,error)
    dispatch(failedTemplates({})); 
}
}

export const editTemplates = async(dispatch,req)=>{
try {
    dispatch(loadingTemplates());
    const data = await putData(TEMPLATE,req);
    await getTemplates(dispatch);
    // nav(-1);
    // dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    dispatch(failedTemplates({})); 
}
}
export const editTemplatesByBusiness = async(dispatch,req)=>{
try {
    dispatch(loadingTemplates());
    const data = await putData(TEMPLATE_BIZZ,req);
    await getTemplatesByBusiness(dispatch);
    // nav(-1);
    // dispatch(successTemplates(data?.data));
} catch (error) {
    console.log(error);
    dispatch(failedTemplates({})); 
}
}